import { Link } from 'react-router-dom';
import { FC, useEffect, useState } from 'react';
import CulturaCard from '../../utils/card';
import "../../styles/home.scss";
import { Image } from "antd"
import GetStorageUser from '../../middlewares/GetStorageUser';

interface CardProps {
    image: string;
    name: string;
    links?: { to?: any; name: string, click?: any }[];
}
const Card: FC<CardProps> = ({ image, name, links }) => {
    links = links || [];
    const [user, setUser] = useState<any>()

    useEffect(() => {
        const userInfo = GetStorageUser()
        setUser(userInfo)
    }, [])


    return (
        <div className="col-12 col-md-6 col-lg-4 mb-3">
            <CulturaCard
                className="h-100 dash-card"
                title={
                    <div className="d-flex"> <Image preview={false} style={{ width: 30, height: 30, marginRight: 10 }} src={image} />
                        <span style={{ fontFamily: 'Montserrat-Regular', color: '#000', fontSize: '12px' }}>
                            ACCESOS RÁPIDOS{''}
                            <h5
                                style={{

                                    fontSize: '14px',
                                    marginBottom: 5,
                                    fontFamily: 'Montserrat-bold',
                                    color: '#000'
                                }}
                            >
                                {name}
                            </h5>
                        </span>
                    </div>
                }
            >
                <ul className="custom-list-style p-0">
                    {links.map((link, i) => {
                        if (user?.role_id !== 1) {
                            console.log(user?.permissions);
                            
                            if (user?.permissions?.some(permiso => permiso?.permission?.route[0]?.route === link?.to)) {
                                return (
                                    <li key={link.to || link.name}>
                                        {link.to && (
                                            <Link to={link.to} onClick={link.click ? link.click : {}} style={{ color: '#000000', textDecoration: 'none', fontFamily: 'Montserrat-Regular', fontSize: '12px' }}>
                                                {link.name}
                                            </Link>
                                        )}
                                        {!link.to && `${link.name}`}
                                    </li>
                                );
                            }
                        } else {
                            return (
                                <li key={link.to || link.name}>
                                    {link.to && (
                                        <Link to={link.to} onClick={link.click ? link.click : {}} style={{ color: '#000000', textDecoration: 'none', fontFamily: 'Montserrat-Regular', fontSize: '12px' }}>
                                            {link.name}
                                        </Link>
                                    )}
                                    {!link.to && `${link.name}`}
                                </li>
                            );
                        }
                    })}
                </ul>
            </CulturaCard>
        </div>
    );
};

export default Card;
